// extracted by mini-css-extract-plugin
export var paginator = "Paginator_paginator__Q7YHC";
export var pageLink = "Paginator_pageLink__cebJg";
export var pageBreak = "Paginator_pageBreak__G4vf3";
export var disabledLink = "Paginator_disabledLink__VT1Rq";
export var activeLink = "Paginator_activeLink__9DvJu";
export var previousLink = "Paginator_previousLink__y5xTp";
export var nextLink = "Paginator_nextLink__yzXqm";
export var rotate = "Paginator_rotate__Wc3Dy";
export var dotty = "Paginator_dotty__BGc4o";